<template>
  <div class="main tabs_main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">部门名称：</span>
        <el-input v-model="departName" :size="size" clearable placeholder="请输入部门名称"></el-input>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" @click="searchDepartmentList(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" @click="propInsert()">新增</el-button>
        <!-- <el-button :size="size" icon="el-icon-upload2" @click="exportExcel()">导出Excel</el-button> -->
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="departmentList"
        height="100%">
        <el-table-column label="序号" width="55" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="departName" label="部门名称" align="center"></el-table-column>
        <el-table-column prop="departAdmin" label="部门负责人" align="center"></el-table-column>
        <el-table-column label="人数" align="center">
          <template #default="{ row }">
            <el-button type="text" @click="propPeople(row)">{{row.departUserCount}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增 修改 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增部门' : '修改部门信息'"
      :visible.sync="asyncDepartment"
      width="35%">
      <el-form ref="form" :model="formDepartment" :rules="rulesDepartment" label-width="auto" class="rule_form">
        <el-form-item label="部门名称：" prop="departName">
          <el-input v-model="formDepartment.departName" :size="size" clearable placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门负责人：" prop="departAdmin">  
          <el-input v-model="formDepartment.departAdmin" :size="size" clearable placeholder="请输入部门负责人"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncDepartment = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()"> 提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="prop_dialog"
      title="人数清单"
      :visible.sync="asyncPeople"
      width="35%">
      <div>
        <el-table
          :data="peopleList"
          height="300">
          <el-table-column prop="jobNum" label="工号" align="center"></el-table-column>
          <el-table-column prop="realName" label="人员姓名" align="center"></el-table-column>
          <el-table-column label="性别" align="center">
            <template #default="{ row }">
              <div>
                {{row.sex === 0 ? '男' : '女'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-pagination
          background
          @current-change="changePeopleNum"
          @size-change="changePeopleSize"
          :current-page="peopleNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="peopleSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="peopleTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../../../pinia/index';
import { changeSize, throttle, downLoadFile } from '../../../../plugins/public';
  export default {
    name: 'DepartmentIndex',
    data() {
      return {
        size: changeSize(),
        departName: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        departmentList: [], // 列表信息
        asyncTitle: true, // 弹窗标题 true 添加部门  false 修改部门信息
        asyncDepartment:false, // 弹窗
        rulesDepartment: {
          departName: [{
            required: true,
            message: '请输入部门名称',
            triggrt: 'blur'
          }],
          departAdmin: [{
            required: true,
            message: '请输入部门负责人',
            triggrt: 'blur'
          }]
        }, // 表单校验规则
        formDepartment: {}, // 表单信息
        asyncPeople: false, // 人数清单
        departId: '',
        peopleList: [], // 人数清单信息
        peopleNum: 1,
        peopleSize: 10,
        peopleTotal: 0,
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchDepartmentList(true);
    },
    methods: {
      // 查询部门列表信息
      searchDepartmentList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.departmentList = [];
        this.$api.Personnerl.SEARCHDEPARTMENTLIST({
          departName: this.departName,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.departmentList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 查询人数清单信息
      searchPeopleList(bol) {
        if(bol) {
          this.peopleNum = 1;
        }
        this.peopleList = [];
        this.$api.Personnerl.getDepartmentUserData({
          departId: this.departId,
          pageNum: this.peopleNum,
          pageSize: this.peopleSize
        }).then((res) => {
          if(res.success) {
            this.peopleList = res.data.list;
            this.peopleTotal = res.data.total;
          }
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncDepartment = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncDepartment = true;
        this.$set(this.formDepartment, 'departId', row.departId);
        this.$set(this.formDepartment, 'departName', row.departName);
        this.$set(this.formDepartment, 'departAdmin', row.departAdmin);
      },
      // 打开人数信息
      propPeople(row) {
        console.log(row);
        this.asyncPeople = true;
        this.departId = row.departId;
        this.searchPeopleList(true);
      },
      // 导出Excel
      exportExcel() {
        this.$api.System.GETEXPORTTOKENDATA({
          departName: this.departName,
        }).then((res) => {
          if(res.success) {
            downLoadFile(res.data, '/staff/depart/export');
          }
        })
      },
      // 删除部门信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该部门，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Personnerl.DELETEDEPARTMENTINFO({departId: row.departId})
        .then(res => {
          if(res.success) {
            this.searchDepartmentList();
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formDepartment);
            this.$api.Personnerl.INSERTDEPARTMENTINFO(params).then((res) => {
              if(res.success) {
                this.asyncDepartment = false;
                this.searchDepartmentList(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formDepartment);
            this.$api.Personnerl.UPDATEDEPARTMENTINFO(params).then((res) => {
              if(res.success) {
                this.asyncDepartment = false;
                this.searchDepartmentList(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchDepartmentList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchDepartmentList();
      },
      // 切换人数清单页数
      changePeopleNum(page) {
        this.peopleNum = page;
        this.searchPeopleList();
      },
      // 切换人数清单每页条数
      changePeopleSize(size) {
        this.peopleSize = size;
        this.searchPeopleList()
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
    },
    watch: {
      asyncDepartment(bol) {
        if(!bol) {
          this.formDepartment = {};
          this.$refs.form.resetFields();
        }
      },
      asyncPeople(bol) {
        if(!bol) {
          this.departId = '';
          this.peopleNum = 1;
          this.peopleSize = 10;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import'@/style/layout-main.scss';
</style>